/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";

export function AsideMenuListAdmin({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/admin/companies", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/admin/companies">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/chart-line-solid.svg")} />
            </span>
            <span className="menu-text">Companies</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/admin/products", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/admin/products">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/box-solid.svg")} />
            </span>
            <span className="menu-text">Products</span>
          </NavLink>
        </li>
         <li
          className={`menu-item ${getMenuItemActive("/admin/recipes", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/admin/recipes">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/laptop.svg")} />
            </span>
            <span className="menu-text">Scan recipes</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/admin/users", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/admin/users">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/users-solid.svg")} />
            </span>
            <span className="menu-text">Users</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/admin/roles", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/admin/roles">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/menu/laptop.svg")} />
            </span>
            <span className="menu-text">Roles</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive(
            "/logout"
          )}`}
          aria-haspopup="true"
          style={{ bottom: "0", position: "absolute" }}
        >
          <NavLink className="menu-link" to="/logout">
            <span className="menu-text">Logout</span>
          </NavLink>
        </li>
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
